<script>
import { mapActions } from "pinia";

import { usePageMonCompte } from "./mixin";
import ProduitsHabituelsOverview from "@/components/organisms/mon-compte/produits-habituels-overview/mobile";
import EspaceFideliteOverview from "@/components/organisms/mon-compte/fidelite-espace-overview/mobile";
import ListesDeCourseOverview from "@/components/organisms/mon-compte/listes-de-courses-overview/mobile";
import Container from "@/components/atoms/container";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import ListItemNavigation from "@/components/molecules/list-item-navigation";
import Card from "@/components/molecules/card";
import Button from "@/components/atoms/button";
import MagasinOverview from "@/components/organisms/mon-compte/magasin-overview";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Popin from "@/components/molecules/popin";
import MagasinSelector from "@/containers/magasin-selector";
import { useAuthStore } from "@/store/auth";
import { isMagasinBascule } from "@/utils/magasin";


export default {
  name: "MonCompteDashboardMobile",
  components: {
    ProduitsHabituelsOverview,
    EspaceFideliteOverview,
    ListesDeCourseOverview,
    Container,
    List,
    ListItemNavigation,
    Card,
    ListItem,
    Button,
    MagasinOverview,
    GridRow,
    GridCol,
    Popin,
    MagasinSelector
  },
  setup() {
    const magasinSelectorPopin = ref(null);
    const {
      client,
      isPro,
      abonnements,
      magasinId,
      isEligibleAliasPaiement,
      listesDeCourse,
      listesDeCourseCount,
      listesDeCourseLoading,
      magasin,
      magasinLoading,
      state,
      error,
      getListesDeCourse,
      getMagasin,
      changeMagasinRattachement,
      isFidCarrefour,
    } = usePageMonCompte(magasinSelectorPopin);

    return {
      client,
      isPro,
      abonnements,
      magasinId,
      isEligibleAliasPaiement,
      listesDeCourse,
      listesDeCourseCount,
      listesDeCourseLoading,
      magasin,
      magasinLoading,
      state,
      error,
      getListesDeCourse,
      getMagasin,
      changeMagasinRattachement,
      magasinSelectorPopin,
      isFidCarrefour,
    };
  },
  async mounted() {
    try {
      await this.getListesDeCourse();
    } catch (e) {}

    try {
      await this.getMagasin();
    } catch (e) {}
  },
  methods: {
    ...mapActions(useAuthStore, ["logout"]),
    async deconnexion() {
      window.scrollTo(0, 0);
      await this.logout();
      this.$router.replace("/");
    }
  }
};
</script>

<template>
  <div>
    <Container>
      <h1 class="u-color-primary u-font-24 u-font-secondary u-font-700 u-mb-md u-mt-sm">
        Bonjour {{ client.attributes.prenom }}
      </h1>
      <GridRow>
        <GridCol
          md="6"
          sm="12"
          class="u-mb-sm"
        >
          <ListesDeCourseOverview :count="listesDeCourseCount" />
        </GridCol>
        <GridCol
          md="6"
          sm="12"
          class="u-mb-sm"
        >
          <ProduitsHabituelsOverview />
        </GridCol>
        <GridCol
          v-if="!isPro"
          md="6"
          sm="12"
        >
          <EspaceFideliteOverview :is-fid-carrefour="isFidCarrefour" />
        </GridCol>
      </GridRow>
    </Container>
    <Card
      tag="nav"
      elevation="md"
      class="u-mt-md"
    >
      <List class="u-flex@sm u-flex-column@sm">
        <ListItemNavigation
          class="u-full-width u-pl-sm"
          to="/mon-compte/mes-commandes"
        >
          Mes achats
        </ListItemNavigation>
        <ListItemNavigation
          v-if="!isPro"
          class="u-full-width u-pl-sm"
          to="/mon-compte/abonnements"
        >
          Mes abonnements
        </ListItemNavigation>
        <ListItemNavigation
          class="u-full-width u-pl-sm"
          to="/mon-compte/mon-profil"
        >
          Mon profil
        </ListItemNavigation>
        <ListItemNavigation
          class="u-full-width u-pl-sm"
          to="/mon-compte/mes-adresses"
        >
          Mes adresses
        </ListItemNavigation>
        <ListItemNavigation
          v-if="isEligibleAliasPaiement && !isPro"
          class="u-full-width u-pl-sm"
          to="/mon-compte/mes-cartes-bancaires"
        >
          Mes cartes bancaires
        </ListItemNavigation>
        <ListItem class="u-full-width u-p-sm">
          <Button
            link
            variant="text"
            class="u-font-500"
            @click="deconnexion"
          >
            Me déconnecter
          </Button>
        </ListItem>
      </List>
    </Card>
    <Container v-if="magasin && !isMagasinBascule(magasin)">
      <h2 class="u-mt-md u-font-19 u-font-secondary u-font-700 u-mb-sm">
        Mes habitudes
      </h2>
    </Container>
    <Card
      v-if="magasin && !isMagasinBascule(magasin)"
      class="u-mb-md u-p-sm"
    >
      <MagasinOverview
        :magasin="magasin"
        :can-change="!isPro"
        class="u-mb-md"
        @change="$refs.magasinSelectorPopin.show()"
      />
    </Card>
    <Popin
      ref="magasinSelectorPopin"
      aria-label="Sélectionner un magasin"
      slide-up
    >
      <MagasinSelector
        :state="state"
        :error="error"
        @selectMagasin="changeMagasinRattachement"
      />
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
</style>
